var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loader)?_c('div',{staticClass:"loader"},[_c('idx-skeleton-chart',{staticClass:"mt-4",attrs:{"type":"area"}})],1):(_vm.chartOptions && !_vm.loader)?_c('div',[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd160ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/highcharts/reports/treatments-tags/panels/invites-evolution.vue
// module id = null
// module chunks = 